import { useState, useEffect } from "react";
import "./MerchantDashboard.css";
import { useSelector } from "react-redux";
import ReactSelect from "react-select";
import {
  getOrganisationDashboard,
  getProviderByOrgName,
} from "../../../config/LiveApi";
import DateFilter from "../../../components/common/DateFilter";

const DashboardHeader = ({
  onOrgNameChange,
  onProviderChange,
  onDateChange,
}) => {
  const role = useSelector((state) => state.userReducer.role);
  const [orgNames, setOrgNames] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [selectedProvider, setSelectedProvider] = useState("All");
  const [providersByType, setProvidersByType] = useState({
    payin: [],
    payout: [],
    both: [],
  });

  const token = useSelector((store) => store.userReducer.token);

  /* -------------------- FETCH ORGS -------------------- */
  useEffect(() => {
    const fetchOrgNames = async () => {
      try {
        if (role !== "mops") {
          const response = await getOrganisationDashboard(token);

          const data = response.data || [];
          const orgList = data.map((org) => org.orgName || org.name);
          setOrgNames(orgList);
        }
      } catch (error) {
        console.error("Error fetching organizations:", error);
      }
    };

    if (token) fetchOrgNames();
  }, [token, role]);

  /* -------------------- FETCH PROVIDERS -------------------- */
  useEffect(() => {
    const fetchProviders = async () => {
      if (!selectedOrg) {
        setProvidersByType({ payin: [], payout: [], both: [] });
        return;
      }

      try {
        const response = await getProviderByOrgName(selectedOrg);
        const providers = response.data || [];

        const grouped = { payin: [], payout: [], both: [] };
        providers.forEach((p) => {
          grouped[p.type]?.push(p.providerName);
        });

        setProvidersByType(grouped);
      } catch (error) {
        console.error("Error fetching provider details:", error);
      }
    };

    fetchProviders();
  }, [selectedOrg]);

  /* -------------------- ORG CHANGE -------------------- */
  useEffect(() => {
    if (!selectedOrg) return;

    onOrgNameChange(selectedOrg);
    setSelectedProvider("All");
    onProviderChange("All");
  }, [selectedOrg]);

  /* -------------------- HANDLERS -------------------- */

  const handleOrgChange = (option) => {
    if (!option) {
      // CLEAR action
      setSelectedOrg(null);
      setSelectedProvider("All");
      setProvidersByType({ payin: [], payout: [], both: [] });
      setSelectedFilter("Day");

      onOrgNameChange(""); // 🔥 clear parent org
      onProviderChange("All"); // reset provider in parent
      return;
    }

    // SELECT action
    setSelectedOrg(option.value);
    setSelectedProvider("All");
    setSelectedFilter("Day");

    onOrgNameChange(option.value);
    onProviderChange("All");
  };

  const handleProviderChange = (provider) => {
    setSelectedProvider(provider);
    onProviderChange(provider);
  };
  /* -------------------- OPTIONS -------------------- */
  const orgOptions = orgNames.map((org) => ({
    value: org,
    label: org,
  }));

  /* -------------------- UI -------------------- */
  return (
    <div className="header-box-cal">
      <div className="dash-head">
        <p className="dash-p">Dashboard</p>

        <ReactSelect
          value={
            selectedOrg ? { value: selectedOrg, label: selectedOrg } : null
          }
          options={orgOptions}
          onChange={handleOrgChange}
          placeholder="Select Organization"
          isClearable
        />
      </div>

      <div className="dash-sub-head">
        <p className="overview">
          Overview of <span className="selectedOrg">{selectedOrg || "-"}</span>
        </p>
      </div>

      <p className="overview">
        Providers:
        <button
          className={`check-provider-details ${selectedProvider === "All" ? "active" : ""}`}
          onClick={() => handleProviderChange("All")}
        >
          All
        </button>
        {["payin", "payout", "both"].map((type) =>
          providersByType[type].map((p) => (
            <button
              key={`${type}-${p}`}
              className={`check-provider-details ${selectedProvider === p ? "active" : ""}`}
              onClick={() => handleProviderChange(p)}
            >
              {type}: {p}
            </button>
          )),
        )}
      </p>
      <DateFilter onDateChange={onDateChange} />
    </div>
  );
};

export default DashboardHeader;
